import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { retrieveRawInitData, retrieveLaunchParams } from '@telegram-apps/sdk';

import { LoginDialog } from '@ui/dialogs';

import { AuthState } from './auth.state';
import { TELEGRAM_HEADERS } from './users.entity';

@Injectable({
  providedIn: 'root'
})
export class TelegramBotService {
  private readonly authState = inject(AuthState);
  private readonly dialog = inject(Dialog);

  init(): void {
    try {
      if (!this.authState.isAuthenticated()) {
        const rawInitData = retrieveRawInitData();

        if (rawInitData) {
          this.authState.telegramData.set({
            initDataRaw: rawInitData as string,
            username: retrieveLaunchParams()?.tgWebAppData?.user?.username || '',
            isCameFromBot: true
          });
          localStorage.setItem(TELEGRAM_HEADERS, JSON.stringify(this.authState.telegramData()));
          setTimeout(() => {
            this.dialog.open(LoginDialog);
          });
        }
      }
    } catch (error) {
      // console.error(error);
    }
  }
}
